// extracted by mini-css-extract-plugin
export default {"container":"style_container__cpfeE","explanation":"style_explanation__56WPO","not_found_image":"style_not_found_image__a6+6H"};